import React, { useEffect, useState } from 'react';
import Order from './Order';

const OrdersContainer = ({
  currentOrders,
  updateOrder,
  handleCurrentOrders, 
  employees, 
  handleCurrentemployees, 
  currentRunningOrders,
  }) => {
  const [sortOrders, setSortOrders] = useState({
    pending: [],
    fulfilled: [],
    running: [],
    warning: [],
    end: []
  });

  useEffect(() => {
    const newSortOrders = {
      pending: [],
      fulfilled: [],
      running: [],
      warning: [],
      end: []
    }

    for (let x = 0; x <= currentOrders.length-1; x++) {
    
      switch (currentOrders[x].state) {
        case 'pending':
          newSortOrders.pending.push(currentOrders[x]);
          break;
        case 'fulfilled':
          newSortOrders.fulfilled.push(currentOrders[x]);
          break;
        case 'running':
          newSortOrders.running.push(currentOrders[x]);
          break;
        case 'warning':
          newSortOrders.warning.push(currentOrders[x]);
          break;
        case 'end':
          newSortOrders.end.push(currentOrders[x]);
          break;
        default:
      };
    }
    setSortOrders(newSortOrders)

  }, [currentOrders, currentRunningOrders, handleCurrentOrders]);

  return (
    <section className='orders'>
        <section className='operations'>
          <section>
            {sortOrders.pending.length > 0 && sortOrders.pending.map((order) => (
              <Order 
                key={order.id} 
                order={order}
                updateOrder={updateOrder}
                handleCurrentOrders={handleCurrentOrders}
                employees={employees}
                handleCurrentemployees={handleCurrentemployees}
              />
            ))}
          </section>
        </section>

        <section className='operations'>
          <section>
          {sortOrders.warning.length > 0 && 
          <>
          {sortOrders.warning.map((order) => (
              <Order 
                key={order.id} 
                order={order}
                updateOrder={updateOrder}
                handleCurrentOrders={handleCurrentOrders}
                employees={employees}
                handleCurrentemployees={handleCurrentemployees}
              />
            ))}
            <br />
            <hr />
            <hr />
            <br />
            </>}
            
          {sortOrders.running.length > 0 && 
            <>
            {sortOrders.running.map((order) => (
              <Order 
                key={order.id} 
                order={order}
                updateOrder={updateOrder}
                handleCurrentOrders={handleCurrentOrders}
                employees={employees}
                handleCurrentemployees={handleCurrentemployees}
              />
            ))}
            <br />
            <hr />
            <hr />
            <br />
            </>
            }

          {sortOrders.fulfilled.length > 0 && 
            <>
            {sortOrders.fulfilled.map((order) => (
              <Order 
                key={order.id} 
                order={order}
                updateOrder={updateOrder}
                handleCurrentOrders={handleCurrentOrders}
                employees={employees}
                handleCurrentemployees={handleCurrentemployees}
              />
            ))}
            </>
            }
          </section>
        </section>
      </section>
  )
}

export default OrdersContainer;